import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routesConfig from './routes';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import apiClient from './components/utils/apiClient';
import useUser from './components/helpers/useUser';
import useToken from './components/helpers/useToken';

export const UserContext = React.createContext(null);

const router = createBrowserRouter(routesConfig);

const App = () => {

  const [token, setToken] = useToken();
  const [classification, setClassification] = useState(null);
  const [confguration, setConfiguration] = useState(null);
  const [fields, setFields] = useState(null);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(null);

  

  const getClassification = async () => {
    try {
        const response = await apiClient.get(`/transactions/custom/classification`);
        if(response?.data) {
          setClassification(response?.data);
        }
      } catch(err) {}
  }

  const getConfiguration = async () => {
    try {
        const response = await apiClient.get(`/misc/configs/dashboard`);
        if(response?.data) {
          setConfiguration(response?.data);
        }
      } catch(err) {}
  }

  const getFields = async () => {
    try {
      const response = await apiClient.get(`/fields`);
      if(response?.data) {
        setFields(response?.data);
      }
    } catch(err) {}
}

useEffect(()=>{
  if(isUserLoggedIn) {
    getConfiguration();
    getClassification();
    getFields();
  }
},[isUserLoggedIn])



  useEffect(()=>{
    if(token && token !== undefined && token !== 'undefined' && token !== 'remove') {
      setIsUserLoggedIn(true);
    }
  },[token])


  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();
  return <UserContext.Provider value={{ isUserLoggedIn: isUserLoggedIn, setIsUserLoggedIn: setIsUserLoggedIn, fields:fields, classification: classification, confguration: confguration }}><RouterProvider router={router} /></UserContext.Provider>;
};

export default App;
